import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import Header from "components/v3/header/Header";
import SocialSignIn from "utils/SocialSignIn";
import GoogleTracking from "services/GoogleTracking";
import SocialButtons from "components/v3/social-buttons/SocialButtons";
import TerminalSocialButton from "components/v3/terminal-social-button/TerminalSocialButton";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import AlertModal from "components/v3/alert-modal/AlertModal";
import LegalLinks from "components/v3/legal-links/LegalLinks";
import SubmitError from "components/v3/submit-error/SubmitError";
import { THEMES } from "common/constants/Constants";
import SignIn from "components/v3/sign-in/SignIn";
import RecaptchaNotice from "components/v3/recaptcha/RecaptchaNotice";
import appPath from "utils/appPath";
import styles from "./styles.module.scss";

class RegistrationSignIn extends React.Component {
    componentWillMount() {
        this._socialLogin = this._socialLogin.bind(this);
    }

    componentWillUnmount() {
        this.socialSignIn.cleanup();
    }

    componentDidMount() {
        this.socialSignIn = new SocialSignIn();

        GoogleTracking.setDataLayerFields({
            action: "SignIn",
            cd9: "sign_in",
            cd13: "sign_in"
        });

        this.props.checkUser();
    }

    _socialLogin(socialSite) {
        GoogleTracking.registerClickEvent("reg-click", `connect_${ socialSite }`);

        this.socialSignIn.login(socialSite, () => {
            this.props.socialLogin(socialSite);
        });
    }

    render() {
        const {
            bloombergSiteUrl,
            forgotPasswordLink,
            signupLink,
            grecaptchaApiKey,
            email,
            password,
            errors,
            thinking,
            onEmailChange,
            onPasswordChange,
            forgotPassword,
            login,
            showAlertModal,
            hasBulkSubsRedirect = false,
            hasSubsRedirect = false,
            location
        } = this.props;

        let subscriptionText;

        if (hasSubsRedirect) {
            subscriptionText = "Sign in to purchase a subscription.";
        } else if (hasBulkSubsRedirect) {
            subscriptionText = "Sign in to purchase a group subscription.";
        }

        return (
            <div>
                <ErrorHandler type="login" errors={ errors }>
                    <SubmitError
                        theme={ THEMES.ERROR_THEME_MODULE_LEVEL }
                    />
                </ErrorHandler>
                <Header title="Sign in">
                    <SubscriptionText text={ subscriptionText } />
                    <CreateAccount signupLink={ signupLink } />
                </Header>
                <div className={ styles.body }>
                    <SignIn
                        forgotPasswordLink={ forgotPasswordLink }
                        grecaptchaApiKey={ grecaptchaApiKey }
                        email={ email }
                        password={ password }
                        errors={ errors }
                        thinking={ thinking }
                        onEmailChange={ onEmailChange }
                        onPasswordChange={ onPasswordChange }
                        forgotPassword={ forgotPassword }
                        login={ login }
                        location={ location }
                    />
                    <ErrorHandler type="socialLogin" errors={ errors }>
                        <AlertModal isOpen={ showAlertModal } onClose={ this.props.closeModal } />
                    </ErrorHandler>
                    { !(hasBulkSubsRedirect || hasSubsRedirect) && (
                        <div>
                            <div className={ styles.socialButtons }>
                                <SocialButtons onClick={ this._socialLogin } />
                            </div>
                            <TerminalSocialButton onClick={ this._socialLogin } />
                        </div>
                    ) }
                    <LegalLinks bloombergSiteUrl={ bloombergSiteUrl } />
                    { appPath.isIframePath() && <RecaptchaNotice /> }
                </div>
            </div>
        );
    }
}

const CreateAccount = ({ signupLink }) => {
    return (
        <span className={ styles.createAccount }>
            Don&apos;t have an account?
            <Link className={ styles.createAccountLink } to={ signupLink } aria-label="Create an account">Create one</Link>
        </span>
    );
};

const SubscriptionText = ({ text }) => {
    if (!text) {
        return null;
    }

    return (
        <span className={ styles.subscriptionText }>
            { text }
        </span>
    );
};

RegistrationSignIn.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    forgotPasswordLink: PropTypes.string.isRequired,
    signupLink: PropTypes.string.isRequired,
    login: PropTypes.func.isRequired,
    socialLogin: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    forgotPassword: PropTypes.func.isRequired,
    grecaptchaApiKey: PropTypes.string,
    errors: PropTypes.object.isRequired,
    password: PropTypes.string,
    thinking: PropTypes.string,
    email: PropTypes.string.isRequired,
    checkUser: PropTypes.func.isRequired,
    hasBulkSubsRedirect: PropTypes.bool
};

export default RegistrationSignIn;
